import { setTrainers } from "@/http/clubsApi";
import { getTrainersQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetTrainersQuery = (clubId: string, userToken: string) => {
  return useQuery({
    queryKey: [...getTrainersQueryKey(), clubId],
    queryFn: () => setTrainers(clubId, userToken),
    select: (response) => response.data.data,
    enabled: !!clubId && !!userToken,
  });
};
